module.exports = __webpack_public_path__ + "static/media/Style2.977dc870.PNG";